function remoteRenderer(config, record) {
  var args = record.args.slice(0);
  if (record.verb) {
    args.unshift('<'+record.verb+'>');
  }

  args.unshift('['+record.name+']');
  rlog(args);
}

module.exports = {
  name: 'remote',
  build: function(config) {
    return (function(config) {
      return function(log) {
        remoteRenderer(config, log);
      }
    })(config);
  }
}
